import { RouteName } from "constant/routeNames";
import { decodeHtmlEntities } from "constant/htmlEntities";
import { Link } from "react-router-dom";

function CategoryCard({ data }: any) {
  //category card in movie page

  return (
    <Link to={`${RouteName.VideoDiscoverRoute}/${data.alt_name}`} className="group block w-[90%]">
      <div className="button-red rounded-full-btn flex h-14 w-full cursor-pointer items-center transition-all duration-300 ease-out group-hover:-translate-y-1 group-hover:scale-[1.03] group-hover:shadow-xl group-hover:shadow-[var(--red)]/30 group-hover:brightness-110 lg:h-20 max-sm:h-16">
        <p className="white-text mx-auto text-base font-bold transition-transform duration-300 group-hover:scale-105 lg:text-xl">
          {decodeHtmlEntities(data.name)}
        </p>
      </div>
    </Link>
  );
}

export default CategoryCard;